// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RadarChartOutlinedSvg from "@ant-design/icons-svg/es/asn/RadarChartOutlined";
import AntdIcon from '../components/AntdIcon';

var RadarChartOutlined = function RadarChartOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RadarChartOutlinedSvg
  }));
};

RadarChartOutlined.displayName = 'RadarChartOutlined';
export default /*#__PURE__*/React.forwardRef(RadarChartOutlined);